import apiClient from './apiService';

class RollCallService {
    constructor() {
        if (RollCallService.instance) {
            return RollCallService.instance;
        }
        RollCallService.instance = this;
    }

    async create(data) {
        try {
            const response = await apiClient.post('/roll-calls', data);
            return response.data;
        } catch (error) {
            console.error('Error creating roll-call:', error);
            throw error.response?.data || error;
        }
    }

    static getInstance() {
        if (!RollCallService.instance) {
            RollCallService.instance = new RollCallService();
        }
        return RollCallService.instance;
    }
}

export default RollCallService.getInstance();
